import React from 'react';
import { Panel, Table, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel, getAccessColor } from '../../components/access-control/utils';

export default function GeneralSettingsPanel({
  user,
  toggleBuilderAdmin,
  toggleBillingAccess,
  handleAccessChangeRequest, // TODO: This needs to be updated to handle the new access levels
  isMobile,
  builder
}) {
  return (
    <Panel>
      <Panel.Heading style={{ fontSize: isMobile ? '1em' : 'inherit' }}>
        <strong>General User Settings</strong>
      </Panel.Heading>
      <Panel.Body style={{ fontSize: isMobile ? '0.9em' : 'inherit' }}>
        <Table bordered condensed striped hover className="cap-access-table">
          <thead>
            <tr>
              <th colSpan={2} style={{ width: '200px', fontSize: isMobile ? '0.9em' : 'inherit' }}>Access Level</th>
            </tr>
            <tr>
              {getUser().userId===user.userId && (
                <td colSpan={2} style={{ width: '200px', fontSize: isMobile ? '0.9em' : 'inherit' }}>
                  You cannot change your own access level
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{builder.name} Admin</strong></td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={user.builderStatus === 'ADMIN'}
                      onChange={toggleBuilderAdmin}
                      disabled={getUser().userId === user.userId}
                    />
                    <span className="elegant-checkbox-slider"></span>
                  </label>
                  <span>{user.builderStatus === 'ADMIN' ? 'Admin Access Enabled' : 'Admin Access Disabled'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>{builder.name} Billing</strong></td>
              <td>
                <div className="elegant-checkbox-container">
                  <label className="elegant-checkbox">
                    <input
                      type="checkbox"
                      checked={user.builderStatus === 'BILLING' || user.builderStatus === 'ADMIN'}
                      onChange={toggleBillingAccess}
                      disabled={user.builderStatus === 'ADMIN'}
                    />
                    <span className="elegant-checkbox-slider"></span>
                  </label>
                  <span>
                    {user.builderStatus === 'ADMIN' 
                      ? 'Included as a Builder Admin' 
                      : user.builderStatus === 'BILLING' 
                        ? 'Billing Access Enabled' 
                        : 'Billing Access Disabled'}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Update Access to All Cameras</strong></td>
              <td style={{ position: 'relative', zIndex: 1000 }}>
                <div style={{ position: 'relative' }}>
                  <DropdownButton
                    title="Select Access Level"
                    id="bulk-access-dropdown"
                    onSelect={(newType) => {
                      handleAccessChangeRequest(user.userId, newType);
                    }}
                    disabled={user.builderStatus === 'ADMIN'}
                    bsSize={isMobile ? "xs" : null}
                  >
                    <MenuItem eventKey="No Access" style={{ backgroundColor: getAccessColor('No Access')}}>{getReadableAccessLevel('No Access', null, isMobile)}</MenuItem>
                    <MenuItem eventKey="DEMO" style={{ backgroundColor: getAccessColor('DEMO')}}>{getReadableAccessLevel('DEMO', null, isMobile)}</MenuItem>
                    <MenuItem eventKey="VIEWER" style={{ backgroundColor: getAccessColor('VIEWER')}}>{getReadableAccessLevel('VIEWER', null, isMobile)}</MenuItem>
                    <MenuItem eventKey="OWNER" style={{ backgroundColor: getAccessColor('OWNER')}}>{getReadableAccessLevel('OWNER', null, isMobile)}</MenuItem>
                    {getUser().role==='ADMIN' && (<MenuItem eventKey="SALES_DEMO" style={{ backgroundColor: getAccessColor('SALES_DEMO')}}>{getReadableAccessLevel('SALES_DEMO', null, isMobile)}</MenuItem>)}
                  </DropdownButton>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </Panel.Body>
    </Panel>
  );
} 